import type { ReviewProps } from '@/components/landing-page/components/review';

export const defaults: Required<ReviewProps> = {
  title: '<b>Erfahrungen:</b> Das sagen unsere Mandanten',
  reviews: [
    {
      message:
        'Sehr zu empfehlen. Ich musste mich um Nichts kümmern und bekam dann die positive Antwort, dass der Fall eingestellt wird - dankeschön an das professionelle Team.',
      name: 'Anja S.',
      link: {
        href: 'https://www.ausgezeichnet.org/bewertungen-sos-verkehrsrecht.de-68VSTZ',
        text: 'Ausgezeichnet.org',
      },
    },
    {
      message:
        'Sehr kompetente Kanzlei. Alle bürokratischen Hürden werden einem abgenommen. Schnell und zuverlässig. Immer wieder gerne.',
      name: 'J. Jack',
      link: {
        href: 'https://goo.gl/maps/2Sd9m69yRPHvkBPx6',
        text: 'Google Maps',
      },
    },
    {
      message:
        'Ich brauchte das erste mal Rechtsbeistand im Verkehrsrecht und meine Wahl bereue ich nicht. Ich war zu schnell unterwegs und wurde geblitzt. Die Kanzlei hat sich um alles gekümmert. Ein Tag nach der Anfrage bekam ich einen Anruf und wurde über alles aufgeklärt. Nach ein paar Wochen wurde das Verfahren eingestellt. Ich bin sehr zu Frieden und kann die Kanzlei nur empfehlen. Ich danke vielmals für den tollen Rechtsbeistand.',
      name: 'John',
      link: {
        href: 'https://www.ausgezeichnet.org/bewertungen-sos-verkehrsrecht.de-68VSTZ',
        text: 'Ausgezeichnet.org',
      },
    },
  ],
};
